import LOGO from "../../assets/img/revamp/vibernets/V Academy (1).jpg";
import {Link, useHistory, useLocation} from "react-router-dom";
import {Button, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import React, {useEffect, useState} from "react";
import "./ViberHeader.scss";
import * as constants from "../../const/constants";
import {ChevronDown} from "react-feather";
import {lang, language} from "../../const/language";
import {AppHeaderDropdown} from "@coreui/react";
import cornerImage from "../../assets/img/institute/avatar-placeholder.png";
import MenuLogo from "../../assets/img/revamp/vibernets/icons8-hamburger-menu-32.png";
import {useDispatch, useSelector} from "react-redux";
import swal from "sweetalert";
import * as commonFunc from "../../utils/commonFunc";
import * as actionClassCreator from "../../store/domain/classes/action";
import {getInstituteTeachers} from "../../services/institute";

export default function ViberHeader({showShadow = true}) {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [teachers, setTeachers] = useState([]);

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    // find user details
    const userType = useSelector((state) => state.auth.userType);
    const userObj = useSelector((state) => state.student.userObj);

    const selectPagination = (data) => dispatch(actionClassCreator.selectPagination(data));
    const selectMyClassPagination = data => dispatch(actionClassCreator.selectMyClassPagination(data))

    // Update window width in state on resize
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        getInstituteTeachers().then(response => {
            if (response && response.success) {
                setTeachers(response.body.teachers);
            }
        });

        // Cleanup on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const routeHandler = (route) => {
        if (route === constants.HOME_INSTITUTE_ROUTE) {
            selectPagination(null);
            history.push(`${constants.HOME_INSTITUTE_ROUTE}`);
        }

        if (route === constants.HOME_MY_CLASS_ROUTE) {
            selectMyClassPagination(null);
        }

        if (route === constants.HOME_PROFILE_ROUTE) {
        }

        // if (route === constants.HOME_COURSE_ROUTE) {
        //     console.log(1234)
        //     history.push(`${constants.HOME_COURSE_ROUTE}`);
        // }

        history.push({
            pathname: `${route}`,
            state: userType
        });
    };

    const reRouteWithId = (place) => {
        if (location.pathname !== '/') {
            // Navigate to Home if not already there, and append hash
            history.push(`/${place ? place : ''}`);
        } else {
            // If already on Home, just scroll to the section
            scrollToSection(place.replace("#", ""));
        }
    };

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            // Smoothly scroll to the element
            element.scrollIntoView({behavior: 'smooth'});
            // Update the hash in the URL without reloading
            window.history.pushState(null, null, `#${id}`);
        }
    };

    const logoutHandler = () => {
        swal({
            title: constants.ALERT_TEXT,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NoText,
                dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    commonFunc.removeCookiesValues().then(r => {
                    });
                    history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                    // commonFunc.notifyMessage("Logout successfully",1);
                    break;
                default:
                    break;
            }
        });
    };

    const isMobile = windowWidth <= 1200;

    const authedUserMoreDropDown = (
        <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
                <div style={{
                    height: '18px',
                    position: 'relative',
                    top: '3px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Link>More</Link> <ChevronDown style={{paddingBottom: 2}}></ChevronDown>
                </div>
            </DropdownToggle>
            <DropdownMenu id={'moreDropDownMenu'}
            >
                {/*{userType === 1 &&*/}
                {/*    <DropdownItem className={""} onClick={() => routeHandler(constants.HOME_MY_CLASS_ROUTE)}>*/}
                {/*        {language[lang].MyClass}*/}
                {/*    </DropdownItem>}*/}

                {/*{userType === 1 &&*/}
                {/*    <DropdownItem className={``} onClick={() => routeHandler(constants.HOME_MY_LESSONS_ROUTE)}>*/}
                {/*        {language[lang].MyLessons}*/}
                {/*    </DropdownItem>}*/}

                {userType === 1 &&
                    <DropdownItem className={``} onClick={() => routeHandler(constants.HOME_MY_COURSE_ROUTE)}>
                        {language[lang].MyCourses}
                    </DropdownItem>}

                {userType === 1 && <DropdownItem className={``} onClick={() => routeHandler(constants.HOME_EXAM_ROUTE)}>
                    {language[lang].Exams}
                </DropdownItem>}

                {userType === 1 && <DropdownItem className={``} onClick={() => routeHandler(constants.HOME_CERTIFICATES_ROUTE)}>
                    {language[lang].MyCertificates}
                </DropdownItem>}

            </DropdownMenu>
        </AppHeaderDropdown>
    );

    const authedUserProfile = (
        <div
            className={"border-red custom-flex-row-item custom-flex-column header-btn-section align-end pd-r-60"}
            style={{width: 400}}>
            <div className="d-none d-lg-flex d-md-flex ml-lg-4"
                 style={{alignItems: "center"}}>
                <div>
                    <div className="user_name">
                        {userObj && userObj.name && userObj.name}</div>
                </div>
                <AppHeaderDropdown direction="down">

                    <DropdownToggle nav>
                        <div style={{
                            width: '45px',
                            height: '45px',
                            borderRadius: '50px',
                            alignContent: "center"
                        }}>
                            <img src={cornerImage} style={{height: '45px'}} alt="user"/>
                        </div>
                    </DropdownToggle>

                    <DropdownMenu className={"profile-dropdown-menu-align"}>
                        <DropdownItem onClick={() => routeHandler(constants.HOME_PROFILE_ROUTE)}>
                            <i className="fa fa-cog"/>{language[lang].Profile}
                        </DropdownItem>

                        <DropdownItem onClick={logoutHandler}><i
                            className="fa fa-lock"/>{language[lang].Logout}</DropdownItem>
                    </DropdownMenu>

                </AppHeaderDropdown>
            </div>
        </div>
    );

    const handleTeachersRoute = () => {
        if (teachers.length > 0) {
            history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_TEACHER_ROUTE}/${teachers[0].urlName}`,
                state: teachers[0]
            })
        }
    }

    const userMobileViewMenu = <>

        {<DropdownItem onClick={() => routeHandler(constants.HOME_PROFILE_ROUTE)}>Home</DropdownItem>}

        {<DropdownItem onClick={handleTeachersRoute}>
            Learnings
        </DropdownItem>}

        {<DropdownItem onClick={() => reRouteWithId('#inquiryForm')}>
            Contact
        </DropdownItem>}

        {<DropdownItem onClick={() => reRouteWithId('#aboutUsSection')}>
            About
        </DropdownItem>}

        {<DropdownItem onClick={() => routeHandler(constants.HOME_HELP_ROUTE)}>
            Help
        </DropdownItem>}

        {/*{userType === 1 && <DropdownItem className={""} onClick={() => routeHandler(constants.HOME_MY_CLASS_ROUTE)}>*/}
        {/*    {language[lang].MyClass}*/}
        {/*</DropdownItem>}*/}

        {/*{userType === 1 && <DropdownItem className={``} onClick={() => routeHandler(constants.HOME_MY_LESSONS_ROUTE)}>*/}
        {/*    {language[lang].MyLessons}*/}
        {/*</DropdownItem>}*/}

        {userType === 1 && <DropdownItem className={``} onClick={() => routeHandler(constants.HOME_MY_COURSE_ROUTE)}>
            {language[lang].MyCourses}
        </DropdownItem>}

        {userType === 1 && <DropdownItem className={``} onClick={() => routeHandler(constants.HOME_EXAM_ROUTE)}>
            {language[lang].Exams}
        </DropdownItem>}

        {userType === 1 && <DropdownItem onClick={() => routeHandler(constants.HOME_PROFILE_ROUTE)}>
            {language[lang].Profile}
        </DropdownItem>}

        {userType === 1 && <DropdownItem onClick={logoutHandler}>
            <Button className={"bg-maroon color-white login-btn-font-mobile-menu"}
                    onClick={logoutHandler}
                    style={{border: 'none', width: '100%', borderRadius: 8,}}>
                Logout
            </Button>
        </DropdownItem>
        }

        {userType === 0 && <DropdownItem onClick={() => setModalHandler("LOGIN")}>
            <Button className={"bg-maroon color-white login-btn-font-mobile-menu"}
                    onClick={() => setModalHandler("LOGIN")}
                    style={{border: 'none', width: '100%', borderRadius: 8,}}>
                Register/Login
            </Button>
        </DropdownItem>
        }
    </>

    const mobileViewMenu =
        (
            <div className={"border-red custom-flex-row-item custom-flex-column header-btn-section align-end pd-r-60"}>
                <AppHeaderDropdown direction="down">
                    <DropdownToggle nav>
                        <div style={{
                            height: '18px',
                            position: 'relative',
                            top: '3px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <img alt={"MENU"} style={{height: 30, width: 30}} src={MenuLogo}/>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu id={'moreDropDownMenu'} className={"profile-dropdown-menu-align"}>
                        {userMobileViewMenu}
                    </DropdownMenu>
                </AppHeaderDropdown>
            </div>
        );

    // handle login/register navigation
    const setModalHandler = (str) => {
        if (str === "LOGIN") {
            console.log("CLICKED")
            history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
            return;
        }
        if (str === "REG") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_REG_ROUTE}`);
            return;
        }
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
    };

    return (
        <header className={"container-fluid p-0 viber-header"}
                style={{
                    height: 95,
                    boxShadow: showShadow ? 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' : 'none'
                }}>

            <div className={"border-blue custom-h-100 custom-flex-column align-center"}>
                <div className={"custom-flex-row border-blue w-100 con-center align-center custom-h-100"}>

                    <div className={"border-red custom-flex-row-item  custom-flex-column align-start pd-l-50"}
                         style={{width: 400}}>
                        <img
                            onClick={() => routeHandler(constants.HOME_INSTITUTE_ROUTE)}
                            className={"border-red"}
                            style={{width: 150, height: 65, cursor: 'pointer', objectFit: 'contain'}}
                            alt={"LOGO"} src={LOGO}/>
                    </div>

                    {
                        !isMobile &&
                        <div className={"border-red custom-flex-row-item custom-flex-column header-nav-section"}
                             style={{flex: 1}}>
                            <div className={"custom-flex-row-links"}>
                                <Link onClick={() => routeHandler(constants.HOME_INSTITUTE_ROUTE)}>Home</Link>
                                <Link onClick={() => routeHandler(constants.HOME_COURSE_ROUTE)}>Courses</Link>
                                <Link onClick={handleTeachersRoute}>Learnings</Link>
                                {userType === 0 && <Link onClick={() => reRouteWithId('#inquiryForm')}>Contact</Link>}
                                <Link onClick={() => reRouteWithId('#aboutUsSection')}>About</Link>
                                <Link onClick={() => routeHandler(constants.HOME_HELP_ROUTE)}>Help</Link>
                                {userType === 1 && authedUserMoreDropDown}
                            </div>
                        </div>
                    }

                    {
                        !isMobile && userType === 0 &&
                        <div
                            className={"border-red custom-flex-row-item custom-flex-column header-btn-section align-end pd-r-60"}
                            style={{width: 400}}>
                            <Button className={"bg-maroon color-white login-btn-font"}
                                    onClick={() => setModalHandler("LOGIN")}
                                    style={{padding: 15, border: 'none', width: 150, borderRadius: 10,}}>
                                REGISTER/LOGIN
                            </Button>
                        </div>
                    }

                    {
                        !isMobile && userType === 1 && authedUserProfile
                    }

                    {
                        isMobile && mobileViewMenu
                    }

                </div>

            </div>

        </header>
    );
}